var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var logger = require('../config/logger');

module.exports = function (_ref) {
  var request = _ref.request,
      multipartRoute = _ref.multipartRoute;

  /**
   * Get an upload URL for an specific file part
   * @param   {Object}  transferOrBoardId Board or Transfer id.
   * @param   {Object}  fileId            File identifier
   * @param   {Number}  partNumber        Which part number to upload
   * @param   {Number}  [multipartId]     Multipart identifier for files in boards
   * @returns {Promise}                   An object containing the upload url, expiring date, etc
   */
  return (
    /*#__PURE__*/
    function () {
      var _getFileUploadURL = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(transferOrBoardId, fileId, partNumber, multipartId) {
        var transferOrBoard, file;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                logger.info("Requesting S3 upload URL for part #".concat(partNumber, " of file ").concat(fileId));
                transferOrBoard = {
                  id: transferOrBoardId
                };
                file = {
                  id: fileId
                };

                if (multipartId) {
                  file.multipart = {
                    id: multipartId
                  };
                }

                return _context.abrupt("return", request.send(multipartRoute(transferOrBoard, file, partNumber)));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getFileUploadURL(_x, _x2, _x3, _x4) {
        return _getFileUploadURL.apply(this, arguments);
      }

      return getFileUploadURL;
    }()
  );
};